export default "__VITE_ASSET__DS7Oy5tU__"